import { SearchIcon, XIcon } from "lucide-react"
import { Button } from "~/components/ui/button"
import { Input } from "~/components/ui/input"
import {
	Popover,
	PopoverContent,
	PopoverTrigger
} from "~/components/ui/popover"
import { cn } from "~/lib/utils"

export function Search({
	value,
	onChange,
	placeholder,
	ariaLabel = placeholder,
	mode = "popover",
	className
}: {
	value: string
	onChange: (value: string) => void
	placeholder: string
	ariaLabel?: string
	mode?: "popover" | "input"
	className?: string
}) {
	if (mode === "input") {
		return (
			<div className={cn("relative", className)}>
				<SearchIcon className="-translate-y-1/2 absolute top-1/2 left-3 size-4 text-icons" />
				<Input
					aria-label={ariaLabel}
					placeholder={placeholder}
					value={value}
					onChange={(event) => onChange(event.target.value)}
					className={cn("pl-9", value && "pr-9")}
				/>
				{value && (
					<Button
						type="button"
						variant="ghost"
						size="icon-sm"
						className="absolute top-1/2 right-1 -translate-y-1/2"
						aria-label="Clear search"
						onClick={() => onChange("")}
					>
						<XIcon className="size-4" />
					</Button>
				)}
			</div>
		)
	}

	return (
		<Popover>
			<PopoverTrigger asChild>
				<Button variant="outline" size="icon" aria-label={ariaLabel}>
					<SearchIcon className="size-4" />
				</Button>
			</PopoverTrigger>
			<PopoverContent align="end" className={cn("p-3", className)}>
				<div className="flex items-center gap-2">
					<Input
						autoFocus
						aria-label={ariaLabel}
						value={value}
						onChange={(event) => onChange(event.target.value)}
						placeholder={placeholder}
					/>
					{value && (
						<Button
							type="button"
							variant="ghost"
							size="icon"
							aria-label="Clear search"
							onClick={() => onChange("")}
						>
							<XIcon className="size-4" />
						</Button>
					)}
				</div>
			</PopoverContent>
		</Popover>
	)
}
